import { gql } from '@apollo/client';

export const CHECK_UNCOMPLETED_ORDERS = gql`
  query checkUncompletedOrders($merchantsId: String!) {
    checkUncompletedOrders(merchantId: $merchantsId) 
  }
`;
